import mapData from "lib/stores/mapData";
import context from "lib/stores/context";

export default function resetToWorldwideView() {
  if (!context.activeCountry && !context.activeRegion) {
    mapData.viewState = {
      ...mapData.viewState,
      latitude: 44,
      longitude: 3.25,
      zoom: -4,//window.innerWidth < 1600 ? -4 : 2,
      target: [0, 0, 0],
      pitch: 0,
      transitionDuration: 1000,
    };
  }
}
